module.exports = __webpack_public_path__ + "img/Structures-3.e67748ab.png";